// extracted by mini-css-extract-plugin
export default {"findPlayers":"styles_findPlayers__+W+Tw","matches":"styles_matches__ZlTl+","matchesList":"styles_matchesList__5aVM3","centered":"styles_centered__w4C80"};